var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32.5195C0.5 14.8465 14.827 0.519531 32.5 0.519531C50.173 0.519531 64.5 14.8465 64.5 32.5195C64.5 50.1925 50.173 64.5195 32.5 64.5195C14.827 64.5195 0.5 50.1925 0.5 32.5195Z",
    fill: "#5CBAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82 22.6024L31.389 30.1704L28.202 33.3574L23.82 28.9754C22.06 27.2154 22.06 24.3624 23.82 22.6024ZM35.139 31.9974L34.177 32.9594L42.144 40.9264L40.551 42.5194L32.584 34.5524L24.617 42.5194L23.023 40.9264L33.545 30.4044C32.883 28.7624 33.568 26.3984 35.372 24.5934C37.572 22.3934 40.604 21.8584 42.144 23.3984C43.684 24.9384 43.149 27.9704 40.949 30.1704C39.144 31.9754 36.78 32.6594 35.139 31.9974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.519531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.9224086aac0590e61a4e15590d642c77.svg";
export { ForwardRef as ReactComponent };